import comp from "./BenchmarksComponent";
export default comp;
